function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { node, shape, func, bool, string } from "prop-types";
import { components } from "react-select";
import classNamesMaker from "classnames";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import IconCross from "#library/assets/icons/jds_cross.svg";
import styles from "./IndicatorContainer.module.css";
export var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    getValue = props.getValue,
    clearValue = props.clearValue,
    _props$selectProps = props.selectProps,
    isDisabled = _props$selectProps.isDisabled,
    indicatorClearLabel = _props$selectProps.indicatorClearLabel,
    hideIndicatorOnSingleSelection = _props$selectProps.hideIndicatorOnSingleSelection,
    onApply = _props$selectProps.onApply;
  var numberSelected = getValue().length;
  var tagClassNames = classNamesMaker(styles["jds-IndicatorContainer__tag"], isDisabled && styles["jds-IndicatorContainer__tag--disabled"]);
  var indicatorClassNames = classNamesMaker(styles["jds-IndicatorContainer"], _defineProperty({}, styles["jds-IndicatorContainer--singleSelection"], hideIndicatorOnSingleSelection && numberSelected === 1));
  var manageClearValue = function manageClearValue(event) {
    clearValue();
    event.preventDefault();
    event.stopPropagation();
    onApply([]);
  };
  return /*#__PURE__*/React.createElement(components.IndicatorsContainer, props, numberSelected > 0 && /*#__PURE__*/React.createElement("div", {
    className: indicatorClassNames
  }, /*#__PURE__*/React.createElement("div", {
    className: tagClassNames
  }, /*#__PURE__*/React.createElement("span", null, numberSelected), /*#__PURE__*/React.createElement("div", {
    role: "button",
    "aria-label": indicatorClearLabel,
    onMouseDown: manageClearValue,
    onTouchEnd: manageClearValue,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(IconCross.id),
    size: ICON_SIZES.SMALL,
    className: styles["jds-IndicatorContainer__remove"]
  })))), children);
};
IndicatorsContainer.propTypes = {
  children: node.isRequired,
  getValue: func.isRequired,
  clearValue: func.isRequired,
  selectProps: shape({
    isDisabled: bool,
    indicatorClearLabel: string,
    onApply: func
  }).isRequired
};